var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// filepath: /D:/xamp8.2/htdocs/chaseit1416/resources/js/store/slices/statusesSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
var initialState = {
    status: '',
    reset: 0,
    status_count_array: {
        Active: 0,
        Accept: 0,
        Decline: 0,
        'No answer': 0,
        Inactive: 0,
    },
    statuses: [],
    past_statuses: [],
    loading: false,
    errors: null,
    lockEnabled: false,
    start_time: '',
    end_time: ''
};
// Create an async thunk for fetching statuses
export var fetchStatuses = createAsyncThunk('statuses/fetchStatuses', function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get('/get_statuses')];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_1 = _a.sent();
                if (axios.isAxiosError(error_1) && error_1.response) {
                    return [2 /*return*/, thunkAPI.rejectWithValue(error_1.response.data.errors)];
                }
                else {
                    return [2 /*return*/, thunkAPI.rejectWithValue({ general: 'An unknown error occurred' })];
                }
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); });
var statusesSlice = createSlice({
    name: 'statuses',
    initialState: initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder
            .addCase(fetchStatuses.pending, function (state) {
            state.loading = true;
            state.errors = null;
        })
            .addCase(fetchStatuses.fulfilled, function (state, action) {
            state.status = action.payload.status;
            state.reset = action.payload.reset;
            state.status_count_array = action.payload.status_count_array;
            state.lockEnabled = action.payload.lockEnabled;
            state.start_time = action.payload.start_time;
            state.end_time = action.payload.end_time;
            if (typeof action.payload.statuses === 'string')
                state.statuses = JSON.parse(action.payload.statuses);
            if (typeof action.payload.past_statuses === 'string')
                state.past_statuses = JSON.parse(action.payload.past_statuses);
            state.loading = false;
        })
            .addCase(fetchStatuses.rejected, function (state, action) {
            state.loading = false;
            state.errors = action.payload;
        });
    },
});
export default statusesSlice.reducer;
